export const getHoursWrapped = (startHour: number, endHour: number) => {
  const endHourWrapped = endHour < startHour ? endHour + 24 : endHour
  return Array.from(
    { length: endHourWrapped - startHour + 1 },
    (_, i) => (startHour + i) % 24,
  )
}
